<script setup lang="ts">
// Per-page selector (25 / 50 / 100) used in the toolbar of every paginated table.
import { useI18n } from 'vue-i18n'

defineProps<{
  modelValue: number
}>()

const emit = defineEmits<{
  'update:modelValue': [value: number]
}>()

const { t } = useI18n()

const options = [25, 50, 100]

function onChange(event: Event): void {
  const target = event.target as HTMLSelectElement
  emit('update:modelValue', Number(target.value))
}
</script>

<template>
  <select
    :value="modelValue"
    :aria-label="t('common.per_page')"
    class="rounded-lg bg-slate-800 border border-slate-700 text-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
    @change="onChange"
  >
    <option v-for="option in options" :key="option" :value="option">{{ option }}</option>
  </select>
</template>
